"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Tue Aug 07 2018
*/

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ConstraintTypeEnum_1 = require("../../model/constraint/ConstraintTypeEnum");

var ConstraintConverterResolver_1 = require("./ConstraintConverterResolver");

var RangeConstraintConverter_1 = require("./RangeConstraintConverter");

var SimpleConstraintConverter_1 = require("./SimpleConstraintConverter");

var WeekDayRestrictionConverter_1 = require("./WeekDayRestrictionConverter");
/**
 * Default implementation of {@link ConstraintConverterResolver}.
 *
 * @author RV
 */


var ConstraintConverterResolverImpl =
/*#__PURE__*/
function (_ConstraintConverterR) {
  _inherits(ConstraintConverterResolverImpl, _ConstraintConverterR);

  function ConstraintConverterResolverImpl(simpleConstraintConverter, rangeConstraintConverter, weekDayRestrictionConverter) {
    var _this;

    _classCallCheck(this, ConstraintConverterResolverImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConstraintConverterResolverImpl).call(this));
    _this.simpleConstraintConverter = simpleConstraintConverter;
    _this.rangeConstraintConverter = rangeConstraintConverter;
    _this.weekDayRestrictionConverter = weekDayRestrictionConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ConstraintConverterResolverImpl, [{
    key: "resolve",
    value: function resolve(type) {
      switch (type) {
        case ConstraintTypeEnum_1.ConstraintTypeEnum.Margin:
        case ConstraintTypeEnum_1.ConstraintTypeEnum.PriceChange:
          return this.rangeConstraintConverter;

        case ConstraintTypeEnum_1.ConstraintTypeEnum.AverageMargin:
        case ConstraintTypeEnum_1.ConstraintTypeEnum.AbovePromotion:
        case ConstraintTypeEnum_1.ConstraintTypeEnum.ListingPriceProtection:
        case ConstraintTypeEnum_1.ConstraintTypeEnum.PromoProtection:
        case ConstraintTypeEnum_1.ConstraintTypeEnum.RepricingFrequency:
          return this.simpleConstraintConverter;

        case ConstraintTypeEnum_1.ConstraintTypeEnum.WeekDayRestriction:
          return this.weekDayRestrictionConverter;

        default:
          {
            throw new Error("Illegal argument exception for given type ".concat(type));
          }
      }
    }
  }]);

  return ConstraintConverterResolverImpl;
}(ConstraintConverterResolver_1.ConstraintConverterResolver);

ConstraintConverterResolverImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SimpleConstraintConverter_1.SimpleConstraintConverter, RangeConstraintConverter_1.RangeConstraintConverter, WeekDayRestrictionConverter_1.WeekDayRestrictionConverter])], ConstraintConverterResolverImpl);
exports.ConstraintConverterResolverImpl = ConstraintConverterResolverImpl;